import { render, staticRenderFns } from "./villagePlan.vue?vue&type=template&id=0a5492ae&scoped=true&"
import script from "./villagePlan.vue?vue&type=script&lang=js&"
export * from "./villagePlan.vue?vue&type=script&lang=js&"
import style0 from "./villagePlan.vue?vue&type=style&index=0&id=0a5492ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5492ae",
  null
  
)

export default component.exports